import { Component, Input } from '@angular/core';
import { SaleItem } from '../../../models/sale-item.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MenuItem } from 'primeng/api';
import { ReportsService } from '../../reports/reports.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SplitButtonModule } from 'primeng/splitbutton';

@Component({
  selector: 'app-list-produt-in-sale-form',
  imports: [
    CommonModule,
    FormsModule,
    SplitButtonModule
  ],
  templateUrl: './list-produt-in-sale-form.component.html'
})
export class ListProdutInSaleFormComponent {


  @Input() itens: SaleItem[] = [];
  @Input() saleId!: number;

  pdfUrl:string  = '';
  searchTerm!: SafeResourceUrl;
  items: MenuItem[] = [];

  constructor(private reportsService: ReportsService, private sanitizer: DomSanitizer){
    this.items = [
            {
              label: 'Imprimir',
              command: () => {
                  this.printScreen();
              }
            },
            {
              label: 'Pdf',
              command: () => {
                  this.downloadPdf();
              }
            }
          ];
  }


  applyFilters() {

  }


  printScreen(){
    window.print();
  }

  downloadPdf(){
    this.reportsService.gerarPdf(this.saleId).subscribe(
      {
        next: (response) => {
          const url = window.URL.createObjectURL(response);
          window.open(url, '_blank');
        },
        error: (error) => {
          console.log(error);
        }
      }
    );
  }

}
